<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template #activator="{ on }">
      <v-btn
        flat
        text
        class="text-capitalize"
        v-on="on"
      >
        <v-icon>sort</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar
        dark
        color="transparent"
        class="elevation-0"
      >
        <v-btn
          icon
          dark
          @click="dialog = false"
        >
          <v-icon color="#099AB1">
            keyboard_arrow_left
          </v-icon>
        </v-btn>
        <v-layout>
          <v-flex
            xs11
            class="d-flex justify-center"
          >
            <v-toolbar-title
              class="cyan--text text--darken-2"
            >
              Ordenar
            </v-toolbar-title>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-container fluid>
        <v-radio-group
          v-model="catalogueSortAsc"
          column
        >
          <v-radio
            class="cyan--text text--darken-2 mb-3"
            color="#099AB1"
            label="Menor Preço"
            :value="true"
          />
          <v-radio
            class="cyan--text text--darken-2"
            color="#099AB1"
            label="Maior Preço"
            :value="false"
          />
        </v-radio-group>
      </v-container>

      <v-card-actions class="justify-center my-4">
        <v-btn
          block
          x-large
          depressed
          dark
          class="text-uppercase"
          color="#099AB1"
          @click="dialog = false"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    column: null,
  }),
  computed: {
    catalogueSortAsc: {
      get() {
        return this.$store.state.catalogueSortAsc;
      },
      set(value) {
        this.$store.commit('SET_CATALOGUE_SORT_ASC', value);
      },
    },
  },
};
</script>
